var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGreyuiPublishIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.798 4.53h2.074v9.526c0 .124.1.226.224.226h1.684a.226.226 0 0 0 .225-.226V4.53h2.08a.225.225 0 0 0 .176-.364L11.118.173a.225.225 0 0 0-.354 0l-3.143 3.99a.226.226 0 0 0 .177.367Zm13.415 8.682H19.53a.226.226 0 0 0-.224.225v4.337H2.577v-4.337a.226.226 0 0 0-.224-.225H.669a.226.226 0 0 0-.225.225v5.576c0 .498.402.9.898.9H20.54a.899.899 0 0 0 .898-.9v-5.576a.226.226 0 0 0-.225-.225Z",
    fill: "#5D5D5D"
  })));
};
export { SvgGreyuiPublishIcon as ReactComponent };
export default __webpack_public_path__ + "371c26c4e9852730c2768d069a4361bf.svg";